import {Component, inject, signal} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {Toast} from 'primeng/toast';
import {GoogleAnalyticsService} from '@xstudioz/services/google-analytics-service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  ga = inject(GoogleAnalyticsService);

  protected readonly title = signal('frontend');
}
